import "core-js/modules/esnext.array.find-last-index.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "avatar-container"
};
const _hoisted_2 = {
  class: "item-list-progress"
};
const _hoisted_3 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_4 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_5 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_6 = {
  class: "item-list"
};
const _hoisted_7 = {
  class: "item-card"
};
const _hoisted_8 = {
  class: "item-value"
};
const _hoisted_9 = {
  class: "item-card"
};
const _hoisted_10 = {
  class: "item-value"
};
const _hoisted_11 = {
  class: "item-card"
};
const _hoisted_12 = {
  class: "item-value"
};
const _hoisted_13 = {
  class: "item-card"
};
const _hoisted_14 = {
  class: "item-value"
};
const _hoisted_15 = {
  class: "item-card"
};
const _hoisted_16 = {
  class: "item-value"
};
const _hoisted_17 = {
  class: "item-card"
};
const _hoisted_18 = {
  class: "item-value"
};
const _hoisted_19 = {
  class: "schedule-status"
};
const _hoisted_20 = {
  key: 0,
  class: "schedule-status-item"
};
const _hoisted_21 = {
  class: "time"
};
const _hoisted_22 = {
  class: "event"
};
const _hoisted_23 = {
  key: 1,
  class: "schedule-status-item is-current"
};
const _hoisted_24 = {
  class: "time"
};
const _hoisted_25 = {
  class: "event"
};
const _hoisted_26 = {
  key: 2,
  class: "schedule-status-item is-waiting"
};
const _hoisted_27 = {
  class: "time"
};
const _hoisted_28 = {
  class: "event"
};
import { computed } from 'vue';
import { ElImage, ElProgress, ElRow } from 'element-plus';
import { getPercentage } from "@/tools/utils";
import 'element-plus/es/components/progress/style/css'; // import {getGender, featOptions} from "@/tools/utils";
// pre-declaration

export default {
  __name: 'RoleStatusCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    roleInfo: {
      type: Object,
      required: true
    },
    scheduleData: {
      type: [Object, null],
      required: true
    },
    translucent: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  setup(__props) {
    const props = __props;
    const currentEvent = computed(() => props.scheduleData?.current_node ?? null);
    const completeEvent = computed(() => {
      if (!props.scheduleData) return null;
      const currentOffset = currentEvent.value?.offset ?? 0;
      const index = props.scheduleData.schedule.findLastIndex(item => {
        return item.roles.includes(props.roleInfo.id) && item.offset < currentOffset;
      });
      return index !== -1 ? props.scheduleData.schedule[index] : null;
    });
    const waitingEvent = computed(() => {
      if (!props.scheduleData) return null;
      const currentOffset = currentEvent.value?.offset ?? 0;
      const index = props.scheduleData.schedule.findIndex(item => {
        return item.roles.includes(props.roleInfo.id) && item.offset > currentOffset;
      });
      return index !== -1 ? props.scheduleData.schedule[index] : null;
    }); // const getOrganizationDesc = () => {
    //   if (!props.data || !props.data.role_sign.organization) return '无组织'
    //   return `${props.data.role_sign.organization}(${featOptions[props.data.role_sign.feats - 1]})`
    // }

    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["role-status-container", __props.translucent ? 'translucent' : ''])
      }, [_createVNode(_unref(ElRow), {
        class: "role-info-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ElImage), {
            src: __props.roleInfo.avatar,
            fit: "cover",
            draggable: "false"
          }, null, 8, ["src"])])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("text", {
          class: "item-title"
        }, "生命值", -1)), _createVNode(_unref(ElProgress), {
          percentage: _unref(getPercentage)(__props.data.role_status.hp, __props.data.role_status.max_hp),
          "text-inside": true,
          "stroke-width": 16,
          class: "attribute-item-progress hp_progress"
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_3, _toDisplayString(`${__props.data.role_status.hp} / ${__props.data.role_status.max_hp}`), 1)]),
          _: 1
        }, 8, ["percentage"])]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("text", {
          class: "item-title"
        }, "法力值", -1)), _createVNode(_unref(ElProgress), {
          percentage: _unref(getPercentage)(__props.data.role_status.mp, __props.data.role_status.max_mp),
          "text-inside": true,
          "stroke-width": 16,
          class: "attribute-item-progress mp_progress"
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_4, _toDisplayString(`${__props.data.role_status.mp} / ${__props.data.role_status.max_mp}`), 1)]),
          _: 1
        }, 8, ["percentage"])]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("text", {
          class: "item-title"
        }, "理智值", -1)), _createVNode(_unref(ElProgress), {
          percentage: _unref(getPercentage)(__props.data.role_status.san, __props.data.role_status.max_san),
          "text-inside": true,
          "stroke-width": 16,
          class: "attribute-item-progress san_progress"
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_5, _toDisplayString(`${__props.data.role_status.san} / ${__props.data.role_status.max_san}`), 1)]),
          _: 1
        }, 8, ["percentage"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("text", {
        class: "item-title"
      }, "神秘等级", -1)), _createElementVNode("text", _hoisted_8, _toDisplayString(__props.data.role_sign.mysterious_level), 1)]), _createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("text", {
        class: "item-title"
      }, "神话知识", -1)), _createElementVNode("text", _hoisted_10, _toDisplayString(__props.data.role_status.mythology), 1)]), _createElementVNode("div", _hoisted_11, [_cache[5] || (_cache[5] = _createElementVNode("text", {
        class: "item-title"
      }, "资产点数", -1)), _createElementVNode("text", _hoisted_12, _toDisplayString(__props.data.role_status.wealth_point), 1)]), _createElementVNode("div", _hoisted_13, [_cache[6] || (_cache[6] = _createElementVNode("text", {
        class: "item-title"
      }, "物理强度", -1)), _createElementVNode("text", _hoisted_14, _toDisplayString(`${__props.data.role_sign.damage_bonus}`), 1)]), _createElementVNode("div", _hoisted_15, [_cache[7] || (_cache[7] = _createElementVNode("text", {
        class: "item-title"
      }, "灵体强度", -1)), _createElementVNode("text", _hoisted_16, _toDisplayString(`${__props.data.role_sign.pow_damage_bonus}`), 1)]), _createElementVNode("div", _hoisted_17, [_cache[8] || (_cache[8] = _createElementVNode("text", {
        class: "item-title"
      }, "移动力", -1)), _createElementVNode("text", _hoisted_18, _toDisplayString(__props.data.role_sign.movement), 1)])]), _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_19, [completeEvent.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("text", null, [_createElementVNode("span", _hoisted_21, _toDisplayString(completeEvent.value.time), 1), _createElementVNode("span", _hoisted_22, "「" + _toDisplayString(completeEvent.value.event) + "」", 1), _cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "status"
      }, "已完成", -1))])])) : _createCommentVNode("", true), currentEvent.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("text", null, [_createElementVNode("span", _hoisted_24, _toDisplayString(currentEvent.value.time), 1), _createElementVNode("span", _hoisted_25, "「" + _toDisplayString(currentEvent.value.event) + "」", 1), _cache[10] || (_cache[10] = _createElementVNode("span", {
        class: "status"
      }, "正发生", -1))])])) : _createCommentVNode("", true), waitingEvent.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("text", null, [_createElementVNode("span", _hoisted_27, _toDisplayString(waitingEvent.value.time), 1), _createElementVNode("span", _hoisted_28, "「" + _toDisplayString(waitingEvent.value.event) + "」", 1), _cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "status"
      }, "等待中", -1))])])) : _createCommentVNode("", true)])], 2);
    };
  }

};